<template>
  <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="modal_login">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{toForget?'忘記密碼':'會員登入'}}</h5>
          <button type="button" class="close" @click="hideLoginPanel">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <login-form v-if="!toForget" :redirect-url="redirectUrl" @goForget="goForget"></login-form>
          <forget-form v-else></forget-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useStore} from "vuex";
import LoginForm from "@componentPath/login/LoginForm";
import ForgetForm from "@componentPath/login/ForgetForm";
export default {
  name: "Login",
  components: {
    LoginForm,
    ForgetForm
  },
  setup () {
    const store = useStore();
    const isLogin = store.getters['auth/isAuthenticated'];

    return { isLogin };
  },
  mounted() {
    window.vueShowLogin = this.showLoginPanel;
  },
  provide() {
    return {
      hideLoginPanel: this.hideLoginPanel
    }
  },
  data() {
    return {
      toForget: false,
      redirectUrl: ""
    }
  },
  methods: {
    showLoginPanel(redirectUrl) {
      this.toForget = false;
      if (this.isLogin) {
        return;
      }

      this.redirectUrl = redirectUrl;
      window.$('#modal_login').modal('show');
    },
    hideLoginPanel() {
      window.$('#modal_login').modal('hide');
    },
    goForget() {
      this.toForget = true;
    }
  },
}
</script>